import { render } from "./FloatingBackButton.vue?vue&type=template&id=0502d12a&scoped=true"
import script from "./FloatingBackButton.vue?vue&type=script&lang=js"
export * from "./FloatingBackButton.vue?vue&type=script&lang=js"

import "./FloatingBackButton.vue?vue&type=style&index=0&id=0502d12a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0502d12a"]])

export default __exports__